

// scroll to top

$('.back-to-top').click(function (e) {
    e.preventDefault();
    $('html, body').animate({ scrollTop: 0 }, 500);
})


// menu drawer
$('.header__mobi-menu').click(function () {
    $('body').toggleClass('menu-drawer-open');
})


function toggleMobiSearchIcon() {
  var $input = $('.header__mobi-search input[name="q"]');
  var $icon = $('.header__mobi-search img');
  if ($input.is(':focus') || $input.val().trim() !== '') {
    $icon.addClass('active');
  } else {
    $icon.removeClass('active');
  }
}

// Initial state
toggleMobiSearchIcon();

// On input, focus, blur
$('.header__mobi-search input[name="q"]').on('input focus blur', function () {
  toggleMobiSearchIcon();
});

$('.header__mobi-search img').click(function (e) {
    e.preventDefault();
    $(this).closest('form').submit();
});



var lastScrollTop = 0;
$(window).scroll(function(event){
   var scroll = $(this).scrollTop();
   if (scroll > lastScrollTop){
    $("body").removeClass("header-fixed_visible");
    if (scroll >= 150) {
      $("body").addClass("header-fixed");
    }else{
      $("body").removeClass("header-fixed");
    }
   } else {
    if (scroll >= 150) {
      $("body").addClass("header-fixed_visible");
  }else{
    $("body").removeClass("header-fixed_visible");
  }
  if (scroll <= 149) {
    $("body").removeClass("header-fixed");
  }
   }
   lastScrollTop = scroll;
});

$('body').on('click','.engraving-modal__close', function(e){
  e.preventDefault();
  $('.text-engraving-target, .map-engraving-target').fadeOut();
});


function storeEngravingData(engravingType) {
  let engravingDetails = {
    type: null,
    details: {}
  };

  // if (localStorage.getItem('engravingDetails')) {
  //   engravingDetails = JSON.parse(localStorage.getItem('engravingDetails'));
  // }

  if (engravingType === 'text') {
    const textValue = $('#custom-engraving').val().trim();
    const fontType = $('#engraving-option-font').val();
    engravingDetails.type = 'text';
    engravingDetails.details = {
      text: textValue,
      font: fontType
    };
  } else if (engravingType === 'map') {
    const mapType = $('#engraving-option-map').val();
    const mapLink = $('#custom-map-engraving').val();
    engravingDetails.type = 'map';
    if(mapType == 'Custom location') {
      engravingDetails.details = {
        mapType: mapType,
        link: mapLink
      };
    } else {
      engravingDetails.details = {
        mapType: mapType,
        link: ''
      };
    }
  }
  localStorage.setItem('engravingDetails', JSON.stringify(engravingDetails));

}

// Selectric
if($('.form__item-select select').length > 0){
  $('.form__item-select select').selectric({disableOnMobile: false, nativeOnMobile: false});
  $('.form__item-select select').on('change load', function() {
    if($(this).val() === "" || $(this).val() === null){
      $(this).closest('.form__item-select').removeClass('has-value');
    } else {
      $(this).closest('.form__item-select').addClass('has-value');
    }
    // if ($(this).val() !== $(this).find('option:first').val()) {
    //   $(this).closest('.form__item-select').addClass('has-value');
    // } else {
    //   $(this).closest('.form__item-select').removeClass('has-value');
    // }
   
  });
}



if($('#custom-engraving').length > 0){
  $('body').on('input keyup paste', '#custom-engraving', function () {
    const text = $(this).val();
    const limitedText = text.split(/\n/).slice(0, 3).join('\n'); // Limit to 3 line breaks
    $(this).val(limitedText);
    if (limitedText) {
      $('.text-engraving-area p').html(limitedText.replace(/\n/g, '<br>'));
    } else {
      $('.text-engraving-area p').text('Enter text');
    }
    var $el = $(this),
    offset = $el.innerHeight() - $el.height();

    if ($el.innerHeight() < this.scrollHeight) {
      // Grow the field if scroll height is smaller
      $el.height(this.scrollHeight - offset);
    } else {
      // Shrink the field and then re-set it to the scroll height in case it needs to shrink
      $el.height(1);
      $el.height(this.scrollHeight - offset);
    }

  });
  $('body').on('click','.engraving-modal-close', function(e){
    e.preventDefault();
    $('#custom-engraving').val('').attr('name','');
    $('#engraving-option-font').val('').attr('name','');
    $('.text-engraving-target').fadeOut();
  });
  $('body').on('click','.engraving-modal-save', function(e){
    e.preventDefault();
    $('#custom-engraving').attr('name','items[0]properties[Text engraving]');
    $('#engraving-option-font').attr('name','items[0]properties[Font]');
    $('.text-engraving-target').fadeOut();

    storeEngravingData('text');
    // Clear other engraving options
    $('#engraving-option-map').val('').attr('name','');
    $('#custom-map-engraving').val('').attr('name','');
  });

  // function validateWordCount(textarea, maxWords) {
  //   const words = $(textarea).val().split(/\s+/);
  //   if (words.length > maxWords) {
  //     $(textarea).val(words.slice(0, maxWords).join(' '));
  //   }
  // }
}
if($('#engraving-option-map').length > 0){
  $('body').on('click','.engraving-map-modal-close', function(e){
    e.preventDefault();
    $('#map-engraving').val('').attr('name','');
    $('#engraving-option-map').val('').attr('name','');
    $('#custom-map-engraving').val('').attr('name','');
    $('.map-engraving-target').fadeOut();
  });
  $('body').on('click','.engraving-map-modal-save', function(e){
    e.preventDefault();
    // $('#map-engraving').attr('name','items[0]properties[Map engraving]');
    $('#engraving-option-map').attr('name','items[0]properties[Map engraving]');
    $('#custom-map-engraving').attr('name','items[0]properties[_Map link]');
    $('.map-engraving-target').fadeOut();
    storeEngravingData('map');
    // Clear other engraving options
    $('#custom-engraving').val('').attr('name','');
    $('#engraving-option-font').val('').attr('name','');
  });
}
// if($(".cart").length > 0){
//   var windowHeight=window.innerHeight;
//   var footerH = $('.footer').length > 0?$('.footer').outerHeight():0;
//   $(".cart").css("height",windowHeight-footerH+"px")
// }

function getCookie(name) {
  const value = "; " + document.cookie;
  const parts = value.split("; " + name + "=");
  if (parts.length == 2) return parts.pop().split(";").shift();
  return null;
}

// Reservation fee terms checkbox
if($('#terms-checkbox').length > 0){
  $('body').on('change','#terms-checkbox', function() {
    $('.build-hero__btn-link').prop('disabled', !$('#terms-checkbox').is(':checked'));
    if($('#terms-checkbox').is(':checked')){
      document.cookie = "secure-slot-terms=agreed; path=/; samesite=lax";
    } else {
      document.cookie = "secure-slot-terms=disagreed; path=/; samesite=lax";
    }
  });
  const secureSlotTerms = getCookie('secure-slot-terms');
  if (secureSlotTerms === 'agreed') {
    $("#terms-checkbox").prop("checked", true);
    $('.build-hero__btn-link').prop('disabled', false);
  }
}

// search start
/*
$(".search-btn").on('click' , function(){
    $(".search__inner").addClass('active');
    $("body").addClass('body-overlay');
})
    */
  $('.header-search').on('focus click', function (e) {
    e.preventDefault();
    $('.header__desk-menu ul li').not('.search-btn').fadeOut(300);
    setTimeout(function(){
      $('.header__desk-menu').addClass('search-active');
      $('.header__inner').addClass('search-bar-open');
    },300)
  });
  $('.search-input-close').on('click',function(e){
    e.preventDefault();
    $('.header__desk-menu').removeClass('search-active');
    $('.header__inner').removeClass('search-bar-open');
    setTimeout(function(){
      $('.header__desk-menu ul li').not('.search-btn').fadeIn(300);
      
    },300)
  })
  $('.header__submit').on('click',function(e){
    e.preventDefault();
    if(!$('.header__desk-menu').hasClass('search-active')){
      $('.header__desk-menu ul li').not('.search-btn').fadeOut(300);
      setTimeout(function(){
        $('.header__desk-menu').addClass('search-active');
        $('.header__inner').addClass('search-bar-open');
      },300)
    } else {
      $(this).closest('form').submit();  
    }
      
  })
$(".search__close").on('click' , function(){
    $(".search__inner").removeClass('active');
    $("body").removeClass('body-overlay');
})
$(".overlay").on('click' , function(){
    $(".search__inner").removeClass('active');
    $("body").removeClass('body-overlay');
    $("body").removeClass('open__edit-form');
    $(".edit__address-wrap").removeClass('active');
})

$('.search__icon img').click(function (e) {
  e.preventDefault();
  $(this).closest('form').submit();
});
// search end
// -----------------selection start------------------



$(".selection__item-wrap p").on('click', function (e) {
  if ($(this).closest('.additional-info-trigger').length > 0) {
    return;
  }
  if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).closest(".selection__item-wrap").next(".selection__item-content").slideUp();
  } else {
      $(this).addClass("active");
      $(this).closest(".selection__item-wrap").next(".selection__item-content").slideDown();
  }
});

$(".additional-info-trigger").on('click', function (e) {
  if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).find('.selection__item-wrap p').removeClass('active');
      $(this).find(".selection__item-content").slideUp();
  } else {

      $(this).addClass("active");
      $(this).find('.selection__item-wrap p').addClass('active');
      $(this).find(".selection__item-content").slideDown();
  }
});

// -----------------selection end------------------


$(".contact-faq__title").click(function () {
  if ($(this).hasClass('active')) {
      $(this).removeClass("active");
      $(this).next(".contact-faq__items").slideUp();
  } else {
      // $(".contact-faq__items").slideUp();
      // $(".contact-faq__title").removeClass("active");
      $(this).addClass("active");
      $(this).next(".contact-faq__items").slideDown();
  }
})


$(".contact-faq__another-title").click(function () {
  if ($(this).hasClass('active')) {
      $(this).removeClass("active");
      $(this).next(".contact-faq__item-content").slideUp();
  } else {
      // $(".contact-faq__item-content").slideUp();
      // $(".contact-faq__another-title").removeClass("active");
      $(this).addClass("active");
      $(this).next(".contact-faq__item-content").slideDown();
  }
})




//   contact-faq__accordion end


// faq start


$(".faq__title").click(function () {
  if ($(this).hasClass('active')) {
      $(this).removeClass("active");
      $(this).next(".faq__items-title").slideUp();
  } else {
      // $(".faq__items-title").slideUp();
      // $(".faq__title").removeClass("active");
      $(this).addClass("active");
      $(this).next(".faq__items-title").slideDown();
  }
})


$(".faq__another-title").click(function () {
  if ($(this).hasClass('active')) {
      $(this).removeClass("active");
      $(this).next(".faq__item-content").slideUp();
  } else {
      // $(".faq__item-content").slideUp();
      // $(".faq__another-title").removeClass("active");
      $(this).addClass("active");
      $(this).next(".faq__item-content").slideDown();
  }
})


// faq end


// newsletter-sign-up checked start


document.querySelectorAll('.newsletter-sign-up__checkbox-item input').forEach(checkbox => {
  checkbox.addEventListener('change', () => {
      const address = document.querySelector('.newsletter-sign-up__address');
      const postCode = document.querySelector('.newsletter-sign-up__post-code');
      const anyChecked = Array.from(document.querySelectorAll('.newsletter-sign-up__checkbox-item input')).some(input => input.checked);

      if (anyChecked) {
          address.style.display = 'block';
          postCode.style.display = 'block';
      } else {
          address.style.display = 'none';
          postCode.style.display = 'none';
      }
  });
});

// newsletter-sign-up checked end

// Mailchimp newsletter signup (AJAX, no redirect)
function mailchimpPlainText(html) {
  var el = document.createElement('div');
  el.innerHTML = html || '';
  return el.textContent || el.innerText || '';
}

$('body').on('submit', '#mc-embedded-subscribe-form', function (e) {
  e.preventDefault();

  var $form = $(this);
  var $btn = $form.find('#mc-embedded-subscribe');
  var $error = $form.find('#mce-error-response');
  var $success = $form.find('#mce-success-response');
  var email = $.trim($form.find('[name="EMAIL"]').val());

  $error.hide().empty();
  $success.hide();

  if (!email) {
    $error.text('Please enter your email address.').show();
    return;
  }

  $btn.prop('disabled', true);

  $.ajax({
    type: 'GET',
    url: $form.attr('data-mailchimp-url') || 'https://anordain.us17.list-manage.com/subscribe/post-json',
    data: {
      u: $form.attr('data-mailchimp-u'),
      id: $form.attr('data-mailchimp-id'),
      EMAIL: email,
      'gdpr[86142]': 'Y',
      b_9011b48ad213932ced37a2ca4_88dd246c14: ''
    },
    dataType: 'jsonp',
    jsonp: 'c',
    cache: false
  })
    .done(function (data) {
      if (data && data.result === 'success') {
        $form.addClass('is-submitted');
        $success.show();
        return;
      }

      var message = mailchimpPlainText(data && data.msg) || 'Something went wrong. Please try again.';
      $error.text(message).show();
    })
    .fail(function () {
      $error.text('Something went wrong. Please try again.').show();
    })
    .always(function () {
      $btn.prop('disabled', false);
    });
});

// news letter form submit js start here 

// document.addEventListener('DOMContentLoaded', function () {
//   const form = document.querySelector('.news__letter');

//   form.addEventListener('submit', function (e) {
//     // Get inputs
//     const addressInput = document.getElementById('address');
//     const codeInput = document.getElementById('code');
//     const tagsAddress = document.getElementById('tags-address');
//     const tagsCode = document.getElementById('tags-code');

//     // Set hidden input values only if inputs have values
//     if (addressInput.value.trim()) {
//       tagsAddress.value = addressInput.value.trim();
//     } else {
//       tagsAddress.value = ''; // Clear the value if empty
//     }

//     if (codeInput.value.trim()) {
//       tagsCode.value = codeInput.value.trim();
//     } else {
//       tagsCode.value = ''; // Clear the value if empty
//     }

//     // // Debugging: Log all submitted tags
//     // const tags = Array.from(form.querySelectorAll('input[name="customer[tags][]"]'))
//     //   .filter(input => input.type === 'checkbox' ? input.checked : input.value.trim())
//     //   .map(input => input.value);

//     // console.log('Submitting with tags:', tags);

//     // // Uncomment for production:
//     // // form.submit();
//   });
// });





// $(document).ready(function() {
//   // Update hidden input for address when user types in the address field
//   $('#address').on('keyup', function() {
//     var addressValue = $(this).val(); 
//     $('#tags-address').val(addressValue); 
//   });

//   // Update hidden input for code when user types in the code field
//   $('#code').on('keyup', function() {
//     var codeValue = $(this).val(); 
//     $('#tags-code').val(codeValue); // Set the hidden input value
//   });
// });


// $(document).ready(function () {
//   $(".news__letter").on("submit", function (e) {
//     var addressField = $("#address");
//     var codeField = $("#code");
//     if (addressField.val().trim() === "") {
//       addressField.removeAttr("name");
//     }

//     if (codeField.val().trim() === "") {
//       codeField.removeAttr("name");
//     }
//   });
// });



// news letter form submit js end here 





// view more js start here 

$(".press-hero__item").slice(0, 4).show(); // Show 4 items by default
if ($(".press-hero__item:hidden").length != 0) {
  $(".press-hero__btn a").show();
}
$(".press-hero__btn a").on("click", function (e) {
  e.preventDefault();
  if ($(".press-hero__item:hidden").length == 0) {
    $(".press-hero__btn a").css("display", "none");
  } else {
    $(".press-hero__item:hidden").slice(0, 4).slideDown();

    if ($(".press-hero__item:hidden").length == 0) {
      $(".press-hero__btn a").css("display", "none");
    } // Show 2 more items on click
  }
});


// view more js end here 
// view more js start here 

$(".newsletter-blogs__item").slice(0, 4).show(); // Show 4 items by default
if ($(".newsletter-blogs__item:hidden").length !== 0) {
  $(".newsletter-blogs__btn a").show();
} else {
  $(".newsletter-blogs__btn a").hide();
}
$(".newsletter-blogs__btn a").on("click", function (e) {
  e.preventDefault();
  if ($(".newsletter-blogs__item:hidden").length === 0) {
    $(".newsletter-blogs__btn a").hide();
  } else {
    $(".newsletter-blogs__item:hidden").slice(0, 4).slideDown();

    if ($(".newsletter-blogs__item:hidden").length === 0) {
      $(".newsletter-blogs__btn a").hide();
    }
  }
});


// view more js end here 


// press-library start



$(".press-library__title").click(function () {
  if ($(this).hasClass('active')) {
      $(this).removeClass("active");
      $(this).next(".press-library__content").slideUp();
  } else {
      $(".press-library__content").slideUp();
      $(".press-library__title").removeClass("active");
      $(this).addClass("active");
      $(this).next(".press-library__content").slideDown();
  }
})


// press-library end



// forget password 
$(".forget__password").on("click",function(){
  $(".login-details__left-bot-wrapper").show();
  $(".login-details__left-top-wrap, .login-details__action").hide();
})





$(document).ready(function () {
  var checkedItems = []; 
  $(".selection__item input[type='checkbox']").on("change", function () {
      var itemId = $(this).attr("id");
      if ($(this).is(":checked")) {
          if (checkedItems.length >= 10) {
              $(this).prop("checked", false);
              return;
          }
          checkedItems.push(itemId);
      } else {
          checkedItems = checkedItems.filter(id => id !== itemId);
      }

      if (checkedItems.length !== 10) { 
        $('.selection__bot-btn a').removeClass('btn-active');
      } else {
        $('.selection__bot-btn a').addClass('btn-active');
      }

      $(".selection__item-select").each(function () {
          var relatedCheckbox = $(this).closest(".selection__item").find("input[type='checkbox']");
          if (relatedCheckbox.is(":checked")) {
              var position = checkedItems.indexOf(relatedCheckbox.attr("id")) + 1;
              $(this).find('span').text(position);
          } else {
              // $(this).hide();       
              $(this).find('span').text('');
       
          }
      });
  });
  $('.selection__bot-btn').on('click', function (e) {
    e.preventDefault();
    var $section = $(this).closest('.selection__inner');
    var $form = $(this).closest('.leather-strap-form');
    var $error = $section.find('.selection__error');

    // Reset any previous error
    if ($error.length) {
      $error.text('').hide();
    }

    // Require exactly 10 selected swatches
    if (checkedItems.length !== 10) {
      return;
    }

    if (checkedItems.length > 0) {
      var index = 1;
      checkedItems.forEach(function (itemId) {
        var name = $('#' + itemId).data('name');
        if ($('#prop-' + index).length === 0) {
          $form.append('<input type="hidden" id="prop-' + index + '" name="properties[Sample ' + index + ']" value="'+name+'">');
        }
        index++;
      })
    }

    if ($form.length) {
      var formData = $form.serialize();
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: formData,
        dataType: 'json',
        success: function(response) {
          window.location.href = "/cart";
        },
        error: function(xhr, status, error) {
          // Optionally show error message
          console.error('Error adding to cart:', error);
        }
      });
    }


  });
});




$(".edit__address-top img").on("click",function(){
  $(".edit__address-wrap").removeClass("active");
  $("body").removeClass("open__edit-form");
})
$(".edit__address-btn").on("click",function(e){
  e.preventDefault();
  $(".edit__address-wrap").addClass("active");
  $("body").addClass("open__edit-form");
})

$('.customer-input_country').each(function(){
  var my_country = $(this).attr('data-default');
  $(this).val(my_country);
  // console.log(my_country);
});



$('.text-slider__items').slick({
  slidesToShow: 2,
  slidesToScroll: 1,
  arrows: false,
  infinite: true,
  responsive: [
      {
          breakpoint: 768,
          settings: {
              slidesToShow: 1,
              infinite: true,
              slidesToScroll: 1
          }
      },
  ]
});



$('main').on('click','.text-slider__left-arrow',function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('main').on('click','.text-slider__right-arrow', function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});

// arrow hidden


if ($(Window).width() < 768) {
  $('.text-slider__items').on('afterChange', function (event, slick, currentSlide) {
    if (currentSlide === 0) {
        $(this).parent().find('.text-slider__left-arrow').addClass('hidden');
    } else {
        $(this).parent().find('.text-slider__left-arrow').removeClass('hidden');
    }
    if (currentSlide === slick.slideCount - 1) {        
        $(this).parent().find('.text-slider__right-arrow').addClass('hidden');
    } else {
        $(this).parent().find('.text-slider__right-arrow').removeClass('hidden');
    }
  });

  
}else{
  $('.text-slider__items').on('afterChange', function (event, slick, currentSlide) {
    if (currentSlide === 0) {
        $(this).parent().find('.text-slider__left-arrow').addClass('hidden');
    } else {
        $(this).parent().find('.text-slider__left-arrow').removeClass('hidden');
    }
    if (currentSlide === slick.slideCount - 2) {        
        $(this).parent().find('.text-slider__right-arrow').addClass('hidden');
    } else {
        $(this).parent().find('.text-slider__right-arrow').removeClass('hidden');
    }
  });
}




// ---------text-slide end----------


// ------------.img-card-enamel start-------------


if ($(Window).width() < 768) {
  $('.img-card__items_enamel').slick({
slidesToShow: 1,
slidesToScroll: 1,
arrows: false,
responsive: [
    {
        breakpoint: 768,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 1
        }
    },
]
});
}



// ------------.img-card-enamel end-------------


// -----------discover start------------

$('.related-articles .img-card__items, .discover__items').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  mobileFirst:true,
  responsive: [
      {
          breakpoint: 480,
          settings: {
              slidesToShow: 2,
              slidesToScroll: 1
          }
      },
       {
          breakpoint: 1025,
          settings: "unslick"
      },
  ]
});






// -----------discover end------------




// -------------product-dropdown start----------------


// $(".main-product__drop-item").on('click',function(){
//     $(".main-product__drop-item").removeClass('active');
   
//     if($(this).hasClass('active'))
//     {
//         $(this).removeClass('active');
//     }
//     else {
//         $(this).addClass('active');
//     }
// })


$(".main-product__drop-item").on('click', function (e) {
  // Add 'active' class to clicked item
  $(".main-product__drop-item").removeClass('active');
  $(this).addClass('active');
  // Prevent dropdown selection from triggering this click event
  e.stopPropagation();
});
// Handle dropdown option selection
$(".main-product__drop-item_dropdown").on('change', function () {
  // Remove 'active' class when an option is selected
  $(".main-product__drop-item").removeClass('active');
});
// -------------product-dropdown end----------------




























$(document).ready(function () {

  if($('.login-modal').length > 0){
    $('body').on('click','.login-modal a', function (e) {
      e.preventDefault();
      $('.pdp-login-section').slideToggle();
      $('.main-product__bot').slideToggle();
    });
    $('body').on('click','.pdp-login__close', function (e) {
      e.preventDefault();
      $('.pdp-login-section').slideToggle();
      $('.main-product__bot').slideToggle();
    });
  }
  // Toggle dropdown visibility
  $('body').on('click','.dropdown-button', function () {
      const $button = $(this);
      const $menu = $button.siblings('.dropdown-menu');
      const isExpanded = $button.attr('aria-expanded') === 'true';
      
      // Close other open dropdowns
      $('.dropdown-menu').not($menu).hide();
      $('.dropdown-button').not($button).attr('aria-expanded', false);

      // Toggle the clicked dropdown
      $button.attr('aria-expanded', !isExpanded);
      $menu.toggle(!isExpanded);
  });

  // Handle item selection
  $('body').on('click','.dropdown-item', function () {
      const $item = $(this);
      const value = $item.data('value');
      const $menu = $item.closest('.dropdown-menu');
      const $parent = $item.closest('.main-product__dropdown');
      const $button = $menu.siblings('.dropdown-button');
      const $hiddenInput = $menu.siblings('input[type="hidden"]');
      $parent.find('.required-field-message').slideUp();
      // Update button text and hidden input value
      $button.text(value);
      $hiddenInput.val(value);
      
      if($button.hasClass('dropdown-data-target')){
        // Store dropdown selection in localStorage
        let dropdownSelections = JSON.parse(localStorage.getItem('dropdownSelections')) || [];
        const selectionData = { target: $button.data('name'), value: value };

        const existingIndex = dropdownSelections.findIndex(item => item.target === selectionData.target);
        if (existingIndex !== -1) {
          dropdownSelections[existingIndex] = selectionData;
        } else {
          dropdownSelections.push(selectionData);
        }

        localStorage.setItem('dropdownSelections', JSON.stringify(dropdownSelections));
      }

      
      // Close the dropdown
      $menu.hide();
      $button.attr('aria-expanded', false);

      if($(this).hasClass('product-add-on-item')){
        let index = $(this).data('index'),
        price = $(this).data('add-on-price'),
        prodId = $(this).data('prod-id'),
        inputName = $('#add-on-prod-'+index).data('name');
        $parent.find('.dropdown-item').removeClass('active');
        $(this).addClass('active');
        if(!$(this).hasClass('none-option')) {
          $('#add-on-prod-'+index).val(prodId);
          $('#add-on-prod-'+index).attr('name',inputName);
        } else {
          $('#add-on-prod-'+index).val('');
          $('#add-on-prod-'+index).attr('name','');
        }
          let totalPrice = $('.select__variant option:selected').data('price-value');
          if($('.dropdown-item.active').length > 0){
            $('.dropdown-item.active').each(function(){
              if($(this).data('add-on-price') > 0){
                totalPrice = parseFloat(totalPrice) + parseFloat($(this).data('add-on-price'));
              }
            })
          }
          if (totalPrice % 1 === 0) {
              $('.price-target span.money').text('£' + totalPrice.toLocaleString());
          } else {
              let formattedPrice = totalPrice.toFixed(2);
              $('.price-target span.money').text('£' + formattedPrice.toLocaleString());
          }      
      } else if($(this).hasClass('custom-list-add-on')){
        let value = $(this).data('value'),
        index = $(this).data('list-id'),
        inputName = $('#custom-list-add-on-'+index).data('name');
        if(!$(this).hasClass('none-option')) {
          // console.log("WE ARE HERE")
          $('#custom-list-add-on-'+index).val(value);
          $('#custom-list-add-on-'+index).attr('name',inputName);
        } else {
          $('#custom-list-add-on-'+index).val('');
          $('#custom-list-add-on-'+index).attr('name','');
        }
      } else if($(this).hasClass('engraving-option')){
        let type = $(this).data('value')
        if(type=='Text engraving'){
          $('.text-engraving-target').fadeIn();
          // $('.text-engraving-modal').show();
          // $('.map-engraving-target').hide();

        } else if(type=='Map engraving'){
          $('.map-engraving-target').fadeIn();
          // $('.text-engraving-modal').hide();
          // $('.map-engraving-modal').show();
        }
      } else if($(this).hasClass('engraving-map')){
        if($(this).hasClass('engraving-map-custom')){
          $('.custom-engraving-wrap').slideDown();
        } else {
          $('.custom-engraving-wrap').slideUp();
        }
        let img = $(this).data('img-src');
        let imgsrcset = $(this).data('img-srcset');

        $('.main-product__img-wrapper .map-engraving-target img').attr('src',img);
        $('.main-product__img-wrapper .map-engraving-target img').attr('srcset',imgsrcset);
      } else if($(this).hasClass('engraving-font')){
        let font = $(this).data('class');
        $('.text-engraving-area p').removeClass().addClass(font);
      }

  });

  // Close dropdown when clicking outside
  $(document).on('click', function (event) {
      if (!$(event.target).closest('.main-product__dropdown').length) {
          $('.dropdown-menu').hide();
          $('.dropdown-button').attr('aria-expanded', false);
      }
  });

  // Check sbst URL parameter after page load (fallback for product pages)
  if ($('.main-product').length > 0 && $('.build-hero__inner').length > 0) {
    var urlParams = new URLSearchParams(window.location.search);
    var sbst = urlParams.get('sbst');
    if (sbst === '1') {
      // Wait a bit to ensure product/variant loading is complete
      setTimeout(function() {
        $('.build-hero__inner').slideDown();
      }, 1000);
    }
    // Check secure-slot-terms cookie and update checkbox/button (fallback)
    setTimeout(function() {
      if ($('#terms-checkbox').length > 0 && $('.build-hero__btn-link').length > 0) {
        const secureSlotTerms = getCookie('secure-slot-terms');
        if (secureSlotTerms === 'agreed') {
          $("#terms-checkbox").prop("checked", true);
          $('.build-hero__btn-link').prop('disabled', false);
        }
      }
    }, 1000);
  }

  
});

